export default __webpack_public_path__ + "static/media/ExampleLogo.2d2ac7d9.svg";